import area from './area-measures'
import downtime from './downtime'
import folder from './folder'
import freerent from './free-rent'
import increase from './increase'
import inflation from './inflation'
import lineitems from './line-items'
import marketlease from './market-lease'
import multifamily from './multifamily'
import namedRecoveryService from './named-recoveries'
import payout from './payout'
import portfolio from './portfolio'
import property from './property'
import recoverygroup from './recovery-groups'
import renewalprobability from './renewal-probability'
import rent from './rent'
import rentroll from './rent-roll'
import systemlineitems from './system-line-items'
import tenantcapital from './tenant-capital'
import tenantcontribution from './tenant-contributions'
import tenantgroup from './tenant-group'

export default {
  area,
  downtime,
  folder,
  freerent,
  increase,
  inflation,
  lineitems,
  marketlease,
  multifamily,
  namedRecoveryService,
  payout,
  portfolio,
  property,
  recoverygroup,
  renewalprobability,
  rent,
  rentroll,
  systemlineitems,
  tenantcapital,
  tenantcontribution,
  tenantgroup,
}